// Category helpers for storefront navigation.

/**
 * Categories worth showing as top-level browse entries. Normally the root
 * nodes; when the catalog has a single root (e.g. one "Sea Food" bucket),
 * its direct children are more useful, so those are returned instead.
 *
 * @param {{ id: string, parentId?: string }[]} categories flat category list
 * @returns {{ id: string, parentId?: string }[]}
 */
export function pickBrowseCategories(categories = []) {
  const roots = categories.filter((category) => !category.parentId);
  if (roots.length !== 1) return roots;
  const children = categories.filter((category) => category.parentId === roots[0].id);
  return children.length ? children : roots;
}
